import { render, staticRenderFns } from "./CorruptionFullEffectsModal.vue?vue&type=template&id=c610eecc&scoped=true&"
import script from "./CorruptionFullEffectsModal.vue?vue&type=script&lang=js&"
export * from "./CorruptionFullEffectsModal.vue?vue&type=script&lang=js&"
import style0 from "./CorruptionFullEffectsModal.vue?vue&type=style&index=0&id=c610eecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c610eecc",
  null
  
)

export default component.exports